export default __webpack_public_path__ + "static/pro@768_2x-1770f791aba378d681df408347fb4720.jpg";